<template>
    <div>
        <div
            :data-id="post.id"
            :class="[likeBoxClass, { 'like-ajax': isVotable, 'btn-liked': hasVoted, 'btn-can-like': !hasVoted }, 'btn']"
            @click="handleClick"
        >
            <i v-if="loading" class="loading fa fa-circle-o-notch fa-spin fa-fw"></i>
            <template v-else>
                <i class="not-liked fa" :class="[toLikeIcon, { 'd-none': hasVoted }]"></i>
                <i class="liked fa" :class="[likedIcon, { 'd-none': !hasVoted }]"></i>
            </template>

            <span class="likes" v-if="displayNumberVotes">{{ votes }}</span>
        </div>
    </div>
</template>

<script>
import {
    mapState
} from "vuex";

export default {
    props: {
        post: {
            type: [Object, String],
            required: true
        },
        votesCount: {
            type: Number,
            default: 0
        },
        displayNumberVotes: {
            type: Boolean,
            default: false
        },
        likeBoxClass: {
            default: 'btn-like-box-horizontal'
        }
    },
    data() {
        return {
            hasVoted: false,
            votes: 0,
            loading: false
        }
    },
    computed: {
        isVotable() {
            // Implement logic to determine if the post is votable
        },
        postId() {
            return typeof this.post === 'object' ? this.post.id : this.post;
        },
        initialVotes() {
            return typeof this.post === 'object' ? this.post.votes_count : this.votesCount;
        },
        ...mapState(['isLoggedIn', 'isAdmin', 'toLikeIcon', 'likedIcon', 'userHasVoted', 'userKey', 'anonymousId', 'allowAnonymousToVote']),
    },
    created() {
        this.votes = this.initialVotes;

        if (this.userHasVoted.includes(this.postId)) {
            this.hasVoted = true;
        }
    },
    methods: {
        handleClick(event) {
            // Stop event propagation (otherwise the link goes to the post URL)
            event.stopPropagation();

            if (this.hasVoted) {
                this.unlikePost();
            } else {
                this.likePost();
            }
        },
        likePost() {
            this.loading = true;

            // Determine URL based on logged-in state
            let url = `/http_api/posts/${this.postId}/`;
            if (!this.isLoggedIn) {
                if (!this.allowAnonymousToVote) {
                    this.promptLogin();
                    return;
                }
                url += `anonymous_votes/${this.anonymousId}`;
            } else {
                url += `votes/${this.userKey}`;
            }

            this.$http.post(url)
                .then(response => {
                    this.votes++;
                    this.hasVoted = true;
                })
                .catch(error => {
                    console.error(error);
                    alert('Sorry, cannot perform action. Please contact support.');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        unlikePost() {
            this.loading = true;

            // Determine URL based on logged-in state
            let url = `/http_api/posts/${this.postId}/`;
            if (!this.isLoggedIn) {
                if (!this.allowAnonymousToVote) {
                    this.promptLogin();
                    return;
                }
                url += `anonymous_votes/${this.anonymousId}`;
            } else {
                url += `votes/${this.userKey}`;
            }

            this.$http.delete(url)
                .then(response => {
                    this.votes--;
                    this.hasVoted = false;
                })
                .catch(error => {
                    console.error(error);
                    alert('Sorry, cannot perform action. Please contact support.');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        promptLogin() {
            this.loading = false;
            $('.login_required').modal('show');
        }
    }
};
</script>
